/* tslint:disable */

declare var Object: any;
export interface ERPpurchaseCostingSheetInterface {
  "id"?: number;
}

export class ERPpurchaseCostingSheet implements ERPpurchaseCostingSheetInterface {
  "id": number;
  constructor(data?: ERPpurchaseCostingSheetInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPpurchaseCostingSheet`.
   */
  public static getModelName() {
    return "ERPpurchaseCostingSheet";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPpurchaseCostingSheet for dynamic purposes.
  **/
  public static factory(data: ERPpurchaseCostingSheetInterface): ERPpurchaseCostingSheet{
    return new ERPpurchaseCostingSheet(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPpurchaseCostingSheet',
      plural: 'ERPpurchaseCostingSheets',
      path: 'ERPpurchaseCostingSheets',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPpurchaseCostingSheet.ts